import { CHANGE_PASSWORD, CHANGE_PASSWORD_ERROR, CHANGE_PASSWORD_SUCCESS, MY_PROFILE, MY_PROFILE_ERROR, MY_PROFILE_SUCCESS ,DELETE_USER ,DELETE_USER_ERROR ,DELETE_USER_SUCCESS } from './constants';
import { IMAGE_UPLOAD_SUCCESS , IMAGE_DELETE_SUCCESS  } from './constants';
export default function myProfileReducer(state, action) {
	switch(action.type){
	case MY_PROFILE :
		return { ...state, loading: true };
	case MY_PROFILE_SUCCESS :
		return { ...state, profile: action.payload, loading: false, error: false };
	case MY_PROFILE_ERROR :
		return { ...state, loading: false, error: true };
	case CHANGE_PASSWORD : 
		return { ...state, loading: true };
	case CHANGE_PASSWORD_SUCCESS :
		return { ...state, profile: action.payload, loading: false, error: false };
	case CHANGE_PASSWORD_ERROR :
		return { ...state, loading: false, error: true };
	case DELETE_USER:
		return { ...state, loading: true, error: false };
	case DELETE_USER_SUCCESS:
		return { ...state, loading: true, error: false };
	case DELETE_USER_ERROR:
		return { ...state, loading: false, error: true };
	case IMAGE_UPLOAD_SUCCESS :
		return { ...state, loading: false, error: false };
	case IMAGE_DELETE_SUCCESS :
		return { ...state, loading: false, error: false };
	default: 
		throw Error('Unknown action: ' + action.type);
	}
}